import { useEffect, useState } from 'react';

import useAxiosAdminFetch from './useAxiosAdminFetch';

/**
 * 로그인한 상점관리자 정보(GET profile). 모바일 로그인은 redux에 역할을 넣지 않아 쿠키 기반으로 읽는다.
 * 미로그인이면 useAxiosAdminFetch가 로그인 화면으로 보낸다.
 */
export default function useAdminProfile() {
  const { fetchData } = useAxiosAdminFetch();
  const [state, setState] = useState({ loading: true, profile: null, status: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await fetchData({
        method: 'GET',
        url: `${process.env.REACT_APP_API_SERVER}profile`,
      });
      if (cancelled) return;
      setState({
        loading: false,
        profile: res?.status === 200 ? res.data?.data || null : null,
        status: res?.status ?? null,
      });
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchData]);

  return {
    ...state,
    storeNo: state.profile?.storeNo ?? null,
    isOwner: state.profile?.role === 'AG001',
  };
}
